import { element } from "prop-types";
import * as fetch from 'isomorphic-fetch';
import { setTimeout } from "timers";
const HEIGHT_TO_DISPLAY: number = 300;
export class footerNavigation {
    nav: any[];
    minHeight: number;
    navLinks: any[];
    noActiveSection: boolean = true;
    activeClass: string =  'current';
    pageSections: any[];
    followIndex: number = -1;
    constructor(footerNavigation: HTMLElement[]) {
        if (footerNavigation != undefined && footerNavigation.length > 0) {
            this.nav = footerNavigation;
            this.getAnchorFields();
        }
    }


    getAnchorFields() {
        let requestString = window.location.href + "GetAnchorFields"
        let result = undefined;

        fetch(requestString)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    response;
                }
                return response.json();
            }).then(body => {
                this.navLinks = body;
                this.setAttributeToView();
                this.initialize();
            });
    }



    setAttributeToView() {
        var viewElements = document.getElementById("footer-nav-sections-js").children;
        if (viewElements.length == this.navLinks.length) {
            for (let i = 0; i < viewElements.length; i++) {
                viewElements[i].setAttribute("id", this.navLinks[i]);
            }
        }
    }
    initialize() {
        const footerNav = document.querySelector('.concert-landing-nav');
        if (footerNav == undefined)
            return;
        this.minHeight = ((window as any).innerHeight * 1 / 3);
        window.onscroll = _ => {
            let activateElement = document.getElementById("details");
            if (this.isInView(activateElement, this.minHeight)) {
                footerNav.classList.add("show-nav");
                footerNav.classList.remove("hide-nav");
            }
            else {
                footerNav.classList.remove("show-nav");
                footerNav.classList.add("hide-nav");
            }
        }

        this.pageSections = [];
        this.pageSections.push(document.getElementById("details"));
        for (let i = 0; i < this.nav.length; i++) {
            let subNavLink = this.nav[i];
            let id = subNavLink.getAttribute('href');
            if (id != "details") {
                this.pageSections.push(document.getElementById(id))
            }
            subNavLink.addEventListener('click', this.updateSubnav);
        }

        window.addEventListener('scroll', () => {
            this.checkNav();
        });
    }

    isInView(el, minHeight: number) {
        let rect = el.getBoundingClientRect();
        return (
            rect.top + minHeight <= (window.innerHeight || document.documentElement.clientHeight)
        );
    }

    headerHeight(): number {
        let headerHeight = 0;
        let viewPortHeight = (Math.max(document.documentElement.clientHeight || window.innerHeight)) * 0.3;
        headerHeight = (document.querySelector(".nav").getBoundingClientRect().height) + viewPortHeight;
        return headerHeight;
    }

    checkNav() {
        let pageSections = this.pageSections;
        console.log("The follow index is" + this.followIndex);
        window.requestAnimationFrame(() => {
            if (pageSections.length > 0) {
                if (this.followIndex !== -1) {
                    //If you're scrolling down and the next section is on the page, update the followIndex
                    if (pageSections[this.followIndex + 1] && pageSections[this.followIndex].getBoundingClientRect().bottom <= this.headerHeight() && pageSections[this.followIndex + 1].getBoundingClientRect().top < this.headerHeight()) {
                        this.followIndex++;
                    }
                    //If you're scrolling up and the previous section is on the page, update the followIndex
                    else if (pageSections[this.followIndex - 1] && pageSections[this.followIndex].getBoundingClientRect().top > this.headerHeight() && pageSections[this.followIndex - 1].getBoundingClientRect().bottom > this.headerHeight()) {
                        this.followIndex--;
                    }
                    //If you're scrolling up and you are exiting the first section, update the followIndex to be reset to -1
                    else if (!pageSections[this.followIndex - 1] && pageSections[this.followIndex].getBoundingClientRect().top > this.headerHeight()) {
                        this.followIndex = -1;
                        this.noActiveSection = true;
                    }
                    console.log("The follow index is " + this.followIndex);
                }
                else {
                    if (pageSections[0].getBoundingClientRect().top <= this.headerHeight()) {
                        this.followIndex = 0;
                    }
                }
                var activeSubnavItem = document.getElementById("concert-landing-nav-links-js").querySelector("." + this.activeClass);
                if (activeSubnavItem) {
                    activeSubnavItem.classList.remove(this.activeClass);
                }
                if (this.noActiveSection) {
                    this.noActiveSection = false;
                }
                else {
                    if (this.followIndex !== -1) {
                        (this.nav[this.followIndex] as HTMLElement).classList.add(this.activeClass);
                    }
                }
            }
        });
    }

    updateSubnav(eve: any) {
        eve.preventDefault();
        let target = eve.target;
        let href = (target as any).getAttribute('href');
        document.getElementById(href).scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        // IE and Edge doesn't have a smooth animaton when scrolling 
        if (/Edge/.test(navigator.userAgent) || !((window as any).ActiveXObject) && "ActiveXObject" in window) {
            setTimeout(() => {
                const footerNav = document.getElementsByClassName('concert-landing-nav-list-link');
                for (let i = 0; i < footerNav.length; i++) {
                    let subNavLink = footerNav[i];
                    let id = subNavLink.classList.remove("current");
                }
                (document.activeElement as any).blur();
                (target as any).classList.add("current");
            }, 300);
        }
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            setTimeout(() => {
                const footerNav = document.getElementsByClassName('concert-landing-nav-list-link');
                for (let i = 0; i < footerNav.length; i++) {
                    let subNavLink = footerNav[i];
                    let id = subNavLink.classList.remove("current");
                }
                (document.activeElement as any).blur();
                (target as any).classList.add("current");
            }, 800);
        }
        
    }


}

    
